import Reflux from 'reflux';
import ModalActions from 'flux/actions/ModalActions';
import Immutable from 'immutable';
import BaseMixin from 'flux/stores/BaseMixin';
import SingleVisibleMixin from 'flux/stores/SingleVisibleMixin';
import PopoverActions from 'flux/actions/PopoverActions';
import keyBinder from 'shared/lib/keyBinder';

/**
 * ModalStore
 *
 * Keeps track of modal visibility
 *
 */
export default Reflux.createStore({
  listenables: [ModalActions],

  mixins: [BaseMixin, SingleVisibleMixin],

  init() {
    this.setState(Immutable.Map());
  },

  onHide(key) {
    this.setVisibility(key, false);

    PopoverActions.hideGroup(key);

    /**
     * re-enable any active keybindings
     */
    keyBinder.enable();
  },

  onShow(key) {
    this.setVisibility(key, true);

    /**
     * Disable any active keybindings temporarily while the modal is visible
     */
    keyBinder.disable();
  },
});
